import React, { FC } from 'react';
import { Chip } from 'common/components';
import { EColor } from 'common/const';
import { IUserListParams } from 'entities/User/User.models';

interface IComponentProps {
  params: IUserListParams;
  onClearFilter: (params: IUserListParams) => void;
}

export const SettingsUserFilterChips: FC<IComponentProps> = ({ params, onClearFilter }) => {
  const show = params.status || params.withoutSubdivision;

  if (!show) {
    return null;
  }

  return (
    <div className="chip-list mb-6">
      {params.status && (
        <Chip
          color={EColor.BrightGreen}
          name="Пользователи"
          value="Не активированы"
          onClear={() => onClearFilter({ status: undefined })}
        />
      )}

      {params.withoutSubdivision && (
        <Chip
          color={EColor.BrightGreen}
          name="Пользователи"
          value="Не привязаны к подразделению"
          onClear={() => onClearFilter({ withoutSubdivision: undefined })}
        />
      )}

      {params.status && params.withoutSubdivision && (
        <Chip
          color={EColor.LightGrey}
          name="Очистить всё"
          onClear={() => onClearFilter({ status: undefined, withoutSubdivision: undefined })}
        />
      )}
    </div>
  );
};
